// copied from v1
import React from "react";
import { ButtonLink } from "@indeed/ifl-components";
import LinkedIn from "@indeed/ifl-icons/LinkedIn";
import Twitter from "@indeed/ifl-icons/Twitter";
import Facebook from "@indeed/ifl-icons/Facebook";
import { objectToGetParams } from "helpers/utils";

export const SocialButton = ({ children, sx, href, props }) => {
  return (
    <ButtonLink
      variant="tertiary"
      size="sm"
      target="_blank"
      href={href}
      iconOnly
      {...props}
      sx={{
        borderRadius: "100%",
        "&:hover": {
          color: "neutral.1000",
        },
        ...sx,
      }}
    >
      {children}
    </ButtonLink>
  );
};

export const FacebookButton = ({ url, quote }) => {
  return (
    <SocialButton
      href={`https://www.facebook.com/sharer/sharer.php${objectToGetParams({
        u: url,
        quote,
      })}`}
    >
      <Facebook />
    </SocialButton>
  );
};
export const LinkedInButton = ({ title, url }) => {
  return (
    <SocialButton
      href={`https://linkedin.com/shareArticle${objectToGetParams({
        url,
        mini: true,
        title,
      })}`}
    >
      <LinkedIn />
    </SocialButton>
  );
};
export const TwitterButton = ({ text }) => {
  return (
    <SocialButton
      href={`https://twitter.com/intent/tweet${objectToGetParams({
        text,
      })}`}
    >
      <Twitter />
    </SocialButton>
  );
};
